import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\VariableExportController::__invoke
* @see app/Http/Controllers/Document/VariableExportController.php
* @route '/api/get-variable-export'
*/
const VariableExportController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: VariableExportController.url(options),
    method: 'post',
})

VariableExportController.definition = {
    methods: ["post"],
    url: '/api/get-variable-export',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\VariableExportController::__invoke
* @see app/Http/Controllers/Document/VariableExportController.php
* @route '/api/get-variable-export'
*/
VariableExportController.url = (options?: RouteQueryOptions) => {
    return VariableExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\VariableExportController::__invoke
* @see app/Http/Controllers/Document/VariableExportController.php
* @route '/api/get-variable-export'
*/
VariableExportController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: VariableExportController.url(options),
    method: 'post',
})

export default VariableExportController